/* eslint-disable no-new */
import SmoothScroll from 'smooth-scroll';

window.addEventListener('DOMContentLoaded', () => {
  new SmoothScroll('a[href*="#"]', {
    header: '.header__inner',
    offset: 50,
  });
});
